import styled from "styled-components";

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const SummaryLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #212121a7;
  letter-spacing: -0.3px;
  margin: 0;
`;

export const SummaryValue = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #000;
  margin: 0;
  letter-spacing: -0.3px;
`;

export const TaxSectionTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #212121;
  margin-bottom: 6px;
  letter-spacing: -0.3px;
`;

export const TaxLabel = styled.p`
  font-size: 14px;
  color: #6B7280;
  margin: 0;
  font-weight: 300;
  letter-spacing: -0.3px;
`;

export const TaxValue = styled.p`
  font-size: 13px;
  color: #6B7280;
  margin: 0;
  text-align: right;
  letter-spacing: -0.3px;
`;

export const SummaryTotal = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: #000;
  text-align: right;
  margin: 0;
  letter-spacing: -0.3px;
`;

export const SummaryDividerSolid = styled.div`
  height: 1px;
  background: #e8e8e8;
  margin-top: 3px;
  margin-bottom: 10px;
`;

export const SummaryDividerDashed = styled.div`
  border-top: 1px dashed #e8e8e8;
  margin: 0px 0 15px;
`;
